module.exports = __webpack_public_path__ + "img/icon-data-diet.7f07f3ae.svg";